export var USER_ARI_PREFIX = 'ari:cloud:identity::user/';
export var TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';